import {limparCamposComError, marcarCampoDeItemComError, marcarCamposDeitensDeLiscaComError, addClassDeError} from './validatorHelps'

export function FormValidator(itens, titulo, descricao, dataInicio, dataValidade, servicoBoleto, dataLimiteBoleto,valorBoleto, notifyError){
    return validarFormBuilder(itens, titulo, descricao, dataInicio, dataValidade, servicoBoleto, dataLimiteBoleto,valorBoleto, notifyError)
}

function validarFormBuilder(itens, titulo, descricao, dataInicio, dataValidade, servicoBoleto, dataLimiteBoleto,valorBoleto, notifyError){
    limparCamposComError(itens)

    // Titulo dos Itens
    let itemIsValid = true
    let itensComError = []
    let itensDeLiscaComError = {}
    for(var i = 0; i < itens.length; i++){
        if(itens[i].pergunta.length <= 0){
            itemIsValid = false
            itensComError.push(i)
        }

        // Quando o tipo do lista, verifica o titulo do campo
        if(itens[i].tipo === "select" || itens[i].tipo === "radio" || itens[i].tipo === "checkbox"){
            for(var j = 0; j < itens[i].opcoes.length; j++){
                const opcao = itens[i].opcoes[j]
                if(opcao.texto.length <= 0){
                    if(itens[i].id in itensDeLiscaComError) {
                        itensDeLiscaComError[itens[i].id].push(opcao)
                    } else{
                        itensDeLiscaComError[itens[i].id] = [opcao]
                    }
                }
            }
            itensDeLiscaComError = checkOpcoesIguais(itens[i].opcoes, itens[i].id, itensDeLiscaComError);
        }
    }
    itensComError.length > 0 && marcarCampoDeItemComError(itensComError)

    // Titulo dos campos do tipo lista
    Object.keys(itensDeLiscaComError).length > 0 && marcarCamposDeitensDeLiscaComError(itensDeLiscaComError)
    
    //  Titulo do Formulário
    if(titulo.length <= 0){
        addClassDeError('titulo-do-formulario', 'input')
    }

    if(descricao.length <= 0){
        addClassDeError('descricao-do-formulario')
    }

    // Data Inicio
    if(dataInicio.length <= 0){
        addClassDeError('calendar-range-start')
    }

    // Data Fim
    if(dataValidade <= 0){
        addClassDeError('calendar-range-end')
    }

    if(dataLimiteBoleto.length > 0 && servicoBoleto === null){
        addClassDeError('select-servico-boleto')
    }
    
    if(dataLimiteBoleto.length > 0 && valorBoleto.length === 0){
        addClassDeError('valor-boleto', 'input');
    }

    if(titulo.length <= 0 || descricao.length <= 0 
        || itemIsValid === false || dataInicio.length <= 0 
        || dataValidade <= 0 || Object.keys(itensDeLiscaComError).length > 0 
        || (dataLimiteBoleto.length > 0 && servicoBoleto === null)
        || (dataLimiteBoleto.length > 0 && valorBoleto.length === 0)){
        notifyError('Campos Invalidos', 'Preencha todos os campos de forma valida')
        return false
    }
    return true
}

function checkOpcoesIguais(opcoes, idItem, itensDeLiscaComError){
    for (let i = 0; i < opcoes.length; i++) {
        for (let k = i + 1; k < opcoes.length; k++) {
            if (opcoes[i].texto !== '' && opcoes[k].texto !== '' && opcoes[i].texto === opcoes[k].texto) {
                if(idItem in itensDeLiscaComError) {
                    itensDeLiscaComError[idItem].push(opcoes[i])
                } else{
                    itensDeLiscaComError[idItem] = [opcoes[i]]
                }
                itensDeLiscaComError[idItem].push(opcoes[k])                  
            }
        }
    }
    return itensDeLiscaComError;
}


// WEBPACK FOOTER //
// ./src/helpers/validators/FormValidator.js